import './triggerLeadsParameters.scss';

export class TriggerLeadsParameters {

    static instance = {
        controller: [
            '$scope',
            TriggerLeadsParameters
        ],
        bindings: {'eventResult': '<'},
        template: require('./triggerLeadsParameters.html')
    };

    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit = () => {
        this.$scope.eventResult = this.eventResult;
    }

}